// src/context/FavoriteContext.js
import React, { createContext, useState, useEffect } from "react";

export const FavoriteContext = createContext();

export const FavoriteProvider = ({ children }) => {
  const [favorites, setFavorites] = useState(() => {
    // Initialize favorites from localStorage or empty array
    const savedFavorites = localStorage.getItem("favorites");
    return savedFavorites ? JSON.parse(savedFavorites) : [];
  });

  // Update localStorage whenever favorites change
  useEffect(() => {
    localStorage.setItem("favorites", JSON.stringify(favorites));
  }, [favorites]);

  const addFavorite = (product) => {
    if (!favorites.some((fav) => fav._id === product._id)) {
      const updatedFavorites = [...favorites, product];
      setFavorites(updatedFavorites);
      console.log("Added to favorites:", product);
    }
  };

  const removeFavorite = (id) => {
    const updatedFavorites = favorites.filter((product) => product._id !== id);
    setFavorites(updatedFavorites);
    console.log("Removed from favorites:", id);
  };

  return (
    <FavoriteContext.Provider
      value={{ favorites, addFavorite, removeFavorite }}
    >
      {children}
    </FavoriteContext.Provider>
  );
};

//correct with 41
